
export default "/assets/star-micro.9fd7ae82.svg"